/* src/app/components/indicator/indicator-add-edit.component.css */
.describeTextTD {
  width: 20%;
  text-align: center;
}
.dropBoxTD {
  width: 30%;
  padding: 5px 5px 5px 5px;
}
.input-group-btn {
  display: none;
}
.shadowBox {
  border: 0px solid var(--border-strong);
  padding: 10px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2), 0 3px 10px 2px rgba(0, 0, 0, 0.19);
  border-radius: 2px;
}
table {
  table-layout: fixed;
  width: 100%;
}
table td {
  width: auto;
}
/*# sourceMappingURL=indicator-add-edit.component.css.map */
